import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { InsertDriveFile as InsertDriveFileIcon } from '@mui/icons-material';

const LazyImage = ({ driveFileId, fileName, size = 'w100', delay = 0 }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [src, setSrc] = useState('');

  useEffect(() => {
    let timer;
    if (driveFileId) {
      timer = setTimeout(() => {
        const imgSrc = `https://drive.google.com/thumbnail?id=${driveFileId}&sz=${size}`;
        setSrc(imgSrc);
      }, delay);
    }
    
    return () => clearTimeout(timer);
  }, [driveFileId, size, delay]);

  return (
    <div style={{ width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {loading && !error && <CircularProgress size={20} />}
      {error && <InsertDriveFileIcon color="primary" />}
      {src && (
        <img
          src={src}
          alt={fileName}
          style={{ 
            width: 40, 
            height: 40, 
            objectFit: 'cover',
            display: loading || error ? 'none' : 'block' 
          }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      )}
    </div>
  );
};

export default LazyImage;